var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachments-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C5 5.44772 5.44772 5 6 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H6C3.23858 19 1 16.7614 1 14C1 13.6157 1.04354 13.2404 1.12636 12.8791L2.10108 13.1025L1.12636 12.8791C1.6356 10.6577 3.62301 9 6 9L16 9C17.6569 9 19 10.3431 19 12C19 13.6569 17.6569 15 16 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11L6 11C4.57584 11 3.38129 11.9933 3.07579 13.326C3.02634 13.5417 3 13.7672 3 14C3 15.6569 4.34315 17 6 17H16C18.7614 17 21 14.7614 21 12C21 9.23858 18.7614 7 16 7H6C5.44772 7 5 6.55228 5 6Z",
    fill: "#787878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.088be8cef6254d315e11c6c483069ce9.svg";
export { ForwardRef as ReactComponent };